
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.215 7.429a.5.5 0 010-.858l3.528-2.117a.5.5 0 01.757.43v4.233a.5.5 0 01-.757.429L5.215 7.429z","fill":"#47D061"}}),_c('path',{attrs:{"d":"M9.5 7h14","stroke":"#47D061"}}),_c('path',{attrs:{"d":"M27.785 6.571a.5.5 0 010 .858l-3.528 2.117a.5.5 0 01-.757-.43V4.884a.5.5 0 01.757-.429l3.528 2.117z","fill":"#47D061"}}),_c('path',{attrs:{"d":"M4.5 1h24v-2h-24v2zm27 3v6h2V4h-2zm-3 9h-24v2h24v-2zm-27-3V4h-2v6h2zm3 3a3 3 0 01-3-3h-2a5 5 0 005 5v-2zm27-3a3 3 0 01-3 3v2a5 5 0 005-5h-2zm-3-9a3 3 0 013 3h2a5 5 0 00-5-5v2zm-24-2a5 5 0 00-5 5h2a3 3 0 013-3v-2z","fill":"#F8F8F8"}})])
          )
        }
      }
    